
import { toast } from 'react-toastify';

export class AppAlert {

    public static Info = (message: string) => toast.info(message, AppAlert.alertConfig);
    public static Error = (message: string) => toast.error(message, AppAlert.errorConfig);
    public static Success = (message: string) => toast.success(message, AppAlert.successConfig);
    public static Warn = (message: string) => toast.warn(message, AppAlert.warnConfig);

    private static alertConfig = {
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true        
    };

    private static errorConfig = {
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true
    };

    private static successConfig = {
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true
    };

    private static warnConfig = {
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true
    };
} 